import React from 'react'
import fb from "./fb.png";
import twitter from "./twitter.png";
import linkedin from "./linkedin.png";
import ig from "./instagram.png";
function Footer() {
  return (
    <div> 
       

<section class="container-fluid footer_section">
<p>
Copyright &copy; 2024 All Rights Group 3 Hackaton
</p>
</section>

</div>
  )
}

export default Footer